/* ══════════════════════════════════════════════════════════════════
   骑行日记的双轨联动。

   **两条轨道共用一个索引。** 左边的文字卡靠 translateX 整张横移，
   右边的照片手风琴靠 flex-grow 开合，动画时长和曲线都在 CSS 里
   （--dur-sun / --ease-sun）—— 这里只负责换索引，不碰任何具体数值。
   想调快慢改 CSS，别改这个文件。

   没有进度条、没有圆点：位置由卡上的「01 / 06」和照片带自己的开口说明。

   悬停即停、可拖动、离开视口停表、`prefers-reduced-motion` 不自动播。
   每个 [data-rd] 各自一份状态，同一页放两个不会互相干扰。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (window.ebRideDiariesLoaded) return;
  window.ebRideDiariesLoaded = true;

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(stage) {
    if (stage.dataset.rdReady) return;
    stage.dataset.rdReady = '1';

    var track = stage.querySelector('[data-rd-track]');
    var strip = stage.querySelector('[data-rd-strip]');
    if (!track || !strip) return;

    var cards = Array.prototype.slice.call(track.children);
    var panels = Array.prototype.slice.call(strip.querySelectorAll('.eb-rd__panel'));
    var total = cards.length;
    if (total < 2) return;

    var root = stage.closest('.eb-rd') || stage;
    var idx = 0;
    var timer = null;

    /* 图说条钉宽 + nowrap：手风琴开合的每一帧都重排文字会抖。
       开口宽度和索引无关（永远是那个比例），所以量一次就够，
       只在容器尺寸变了的时候重算。 */
    function measure() {
      var w = strip.clientWidth;
      if (w < 40) return;   /* 还没布局 / 在隐藏的标签页里，量到 0 会算出负数 */
      var open = parseFloat(getComputedStyle(stage).getPropertyValue('--rd-panel-open')) || 5.2;
      strip.style.setProperty('--rd-cap-w', Math.round(w * open / (open + total - 1)) + 'px');
    }

    function render() {
      track.style.transform = 'translateX(' + (-idx * 100) + '%)';
      cards.forEach(function (c, i) { c.classList.toggle('is-on', i === idx); });
      panels.forEach(function (p, i) {
        p.classList.toggle('is-on', i === idx);
        p.setAttribute('aria-selected', i === idx ? 'true' : 'false');
        p.tabIndex = i === idx ? 0 : -1;
      });
    }

    function interval() {
      var v = parseFloat(getComputedStyle(root).getPropertyValue('--rd-interval'));
      return v > 0 ? v * 1000 : 0;   /* 后台把秒数设成 0 = 不自动播 */
    }

    function run() {
      clearTimeout(timer);
      if (REDUCED.matches) return;
      var ms = interval();
      if (!ms) return;
      timer = setTimeout(function () { go(idx + 1); }, ms);
    }

    function go(n) {
      idx = (n % total + total) % total;
      render();
      run();
    }

    panels.forEach(function (p, i) {
      p.addEventListener('click', function () { go(i); });
      p.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); go(idx + 1); panels[idx].focus(); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); go(idx - 1); panels[idx].focus(); }
        if (e.key === 'Home') { e.preventDefault(); go(0); panels[0].focus(); }
        if (e.key === 'End') { e.preventDefault(); go(total - 1); panels[total - 1].focus(); }
      });
    });

    var prev = root.querySelector('[data-rd-prev]');
    var next = root.querySelector('[data-rd-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });

    /* 悬停 / 聚焦即停：别在人正在读的时候把卡推走 */
    stage.addEventListener('mouseenter', function () { clearTimeout(timer); });
    stage.addEventListener('mouseleave', run);
    stage.addEventListener('focusin', function () { clearTimeout(timer); });
    stage.addEventListener('focusout', run);

    /* 拖动 / 滑动。竖向位移更大的时候不拦，那是在滚页面。 */
    var sx = 0, sy = 0, dragging = false;
    stage.addEventListener('pointerdown', function (e) { sx = e.clientX; sy = e.clientY; dragging = true; });
    stage.addEventListener('pointerup', function (e) {
      if (!dragging) return;
      dragging = false;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > 46 && Math.abs(dx) > Math.abs(e.clientY - sy)) go(idx + (dx < 0 ? 1 : -1));
    });
    stage.addEventListener('pointercancel', function () { dragging = false; });

    /* 离开视口就停表，省电也省得回来时正好跳一格 */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { measure(); run(); } else { clearTimeout(timer); }
        });
      }, { threshold: 0.25 }).observe(stage);
    }
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(stage);

    measure();
    render();
    run();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-rd]').forEach(init);
  }

  boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
